import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { EnquiryProvider } from "@/context/EnquiryContext";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import AboutIndia from "@/pages/AboutIndia";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminTours from "@/pages/admin/AdminTours";
import AdminDestinations from "@/pages/admin/AdminDestinations";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminUsers from "@/pages/admin/AdminUsers";

// Content Studio (/cms)
import CmsLogin from "@/pages/cms/CmsLogin";
import CmsLayout from "@/pages/cms/CmsLayout";
import CmsDashboard from "@/pages/cms/CmsDashboard";
import CmsPages from "@/pages/cms/CmsPages";
import CmsMedia from "@/pages/cms/CmsMedia";

function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <AuthProvider>
          <EnquiryProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors closeButton />
              <Routes>
                {/* Public */}
                <Route element={<SiteLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about-india" element={<AboutIndia />} />
                  <Route path="/tours" element={<Tours />} />
                  <Route path="/tours/:slug" element={<TourDetail />} />
                  <Route path="/destinations" element={<Destinations />} />
                  <Route path="/destinations/:slug" element={<DestinationDetail />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/testimonials" element={<Testimonials />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/privacy-policy" element={<Legal />} />
                  <Route path="/terms" element={<Legal />} />
                  <Route path="/cancellation-policy" element={<Legal />} />
                  <Route path="/cookie-policy" element={<Legal />} />
                </Route>

                {/* Admin (technical dashboard) */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="tours" element={<AdminTours />} />
                  <Route path="destinations" element={<AdminDestinations />} />
                  <Route path="blog" element={<AdminBlog />} />
                  <Route path="testimonials" element={<AdminTestimonials />} />
                  <Route path="faqs" element={<AdminFaqs />} />
                  <Route path="enquiries" element={<AdminEnquiries />} />
                  <Route path="homepage" element={<AdminHomepage />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>

                {/* CMS — Content Studio (separate editor-focused panel) */}
                <Route path="/cms/login" element={<CmsLogin />} />
                <Route path="/cms" element={<CmsLayout />}>
                  <Route index element={<CmsDashboard />} />
                  <Route path="pages" element={<CmsPages />} />
                  <Route path="homepage" element={<AdminHomepage />} />
                  <Route path="tours" element={<AdminTours />} />
                  <Route path="destinations" element={<AdminDestinations />} />
                  <Route path="blog" element={<AdminBlog />} />
                  <Route path="testimonials" element={<AdminTestimonials />} />
                  <Route path="faqs" element={<AdminFaqs />} />
                  <Route path="enquiries" element={<AdminEnquiries />} />
                  <Route path="media" element={<CmsMedia />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </EnquiryProvider>
        </AuthProvider>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
